import styled from 'styled-components'

import { WrapPopupDel } from '../../../../../MerchantList/MerchantItem/OptionMerchant/PopupDelMerchant/index.styles';

const WrapPopupDeleteStore = styled(WrapPopupDel)`
    width: 229px;
    .sub-title {
        margin-top: 10px;
    }

    .notice {
        margin-top: 25px;
    }

    .btn-del {
        margin-top: 30px;
    }

    .btn-cancel {
        margin-top: 10px;
    }
`;

export {
    WrapPopupDeleteStore
}